import getStore from '../store/store';
export default (function () { return getStore().query; });
//# sourceMappingURL=getQuery.js.map